module.exports = __webpack_public_path__ + "full-fix.svg";